import { render, staticRenderFns } from "./ContactFormSource.vue?vue&type=template&id=74f5f84c&scoped=true&"
import script from "./ContactFormSource.vue?vue&type=script&lang=ts&"
export * from "./ContactFormSource.vue?vue&type=script&lang=ts&"
import style0 from "./ContactFormSource.vue?vue&type=style&index=0&id=74f5f84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f5f84c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
